import {useAuth0} from "@auth0/auth0-react";
import React, {useEffect, useState} from "react";
import {CodeSnippet} from "../../components/code-snippet";
import {PageLayout} from "../../components/page-layout";
import {useForm} from "react-hook-form";
import {getUserForEmail} from "../../services/admin.service";
import { toast } from 'react-toastify';

export const PageUtils = () => {
    const {getAccessTokenSilently} = useAuth0();

    const [userId, setUserId] = useState("");
    const [error, setError] = useState("");

    const {register, handleSubmit, watch, formState: {errors}} = useForm();
    const onSubmit = data => getUserId(data.email)

    const getUserId = async (email) => {
        console.log("getUserId", email);
        const accessToken = await getAccessTokenSilently();
        const {data, error} = await getUserForEmail(accessToken, email);

        if (data) {
            setError("")
            setUserId(data.id);
            toast.success('Utilisateur trouvé');
        }

        if (error) {
            setUserId("")
            setError(JSON.stringify(error, null, 2));
        }
    };

    //copy
    const [isCopied, setIsCopied] = useState(false);

    async function copyTextToClipboard(text) {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand('copy', true, text);
        }
    }

    const handleCopyClick = () => {
        // Asynchronously call copyTextToClipboard
        copyTextToClipboard(userId)
            .then(() => {
                // If successful, update the isCopied state value
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 1500);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <PageLayout>
            <div className="content-layout">
                <h1 id="page-title" className="content__title">
                    Get user ID
                </h1>
                <div className="content__body">
                    <p id="page-description">
                    <span>
                      This page retrieves a <strong>user ID</strong> from an email.
                    </span>
                    </p>
                    <div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <p>
                                <input {...register("email", {required: true})} />
                            </p>
                            {errors.email && <p>This field is required</p>}
                            <input type="submit" className="button button--compact button--primary"/>
                        </form>
                        {userId && <div>
                            <span>{userId}</span>
                            <button onClick={handleCopyClick}>
                                <span>{isCopied ? 'Copied!' : 'Copy'}</span>
                            </button>
                        </div>}
                        {error && <CodeSnippet title="Protected Message" code={error}/>}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};